import { AppSettings } from "@/AppSettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Paper, styled, ToggleButton, ToggleButtonGroup, ToggleButtonProps } from "@mui/material";
import { FC } from "react";
import ListViewType from "@/types/list/ListViewType";
import { StatusListItemTooltip } from "../status/StatusListStats";
import { NotesAndQueriesListSortTooltip } from "../notes/NotesAndQueriesListSort";

interface IListTableToggleProps {
    onChange: (val: ListViewType) => any;
    value: ListViewType;
}

const listViewTypeToText = (listViewType: ListViewType) => {
    switch(listViewType) {
        case ListViewType.List:
            return "List";
        case ListViewType.Table:
            return "Table"
    }
}

const listViewTypeToIcon = (listViewType: ListViewType) => {
    switch(listViewType) {
        case ListViewType.List:
            return AppSettings.icons.itemGrid;
        case ListViewType.Table:
            return AppSettings.icons.table;
    }
}

const StyledToggleButton = styled(ToggleButton) (() => ({
}))

const OptionButton: FC<ToggleButtonProps> = ({
    ...props
}) => {
    return (
        <NotesAndQueriesListSortTooltip
            placement="top"
            title={
                <>
                    <strong>View</strong>
                    <Box>
                        {
                            listViewTypeToText(props.value as ListViewType)
                        }
                    </Box>
                </>
            }
        >
            <StyledToggleButton
                {...props}
            >
                <FontAwesomeIcon icon={listViewTypeToIcon(props.value as ListViewType)} style={{fontSize: '1.2rem'}} />
            </StyledToggleButton>
        </NotesAndQueriesListSortTooltip>
    )
}

const ListTableToggle: FC<IListTableToggleProps> = ({
    onChange,
    value
}) => {
    return (
        <ToggleButtonGroup
            value={[value]}
            onChange={(e, v) => {  onChange(+(e.currentTarget as any).value as ListViewType); }}
            color="primary"
        >
            <OptionButton value={ListViewType.List} />
            <OptionButton value={ListViewType.Table} />
        </ToggleButtonGroup>
    );
}

export default ListTableToggle;